import { Transition } from '@headlessui/react'
import { useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  RingingBlueStar,
  RingingLine,
  RingingYellowStar,
} from 'shared/components/icon-pack/icons'
import { SocketContext } from 'shared/contexts/socket/socket-context'
import {
  resetRingingData,
  setIsRinging,
} from 'store/slice/call-detail/call-detail.slice'
import { RingingDataType } from 'store/slice/call-detail/types'
import { RootState } from 'store/store'

import { HangupEventType } from '../types/hangup-event.type'
import CallerNameContainer from './caller-name-container'
import OrderHistory from './order-history'
import PhoneNumberContainer from './phone-number-container'
import RingingAvatar from './ringing-avatar'

type PropsType = {
  phoneNumber: string
  callerName: string
  invoiceCount: number
  onHold: () => void | Promise<void>
  preName?: RingingDataType['preName']
}

const Ringing = ({
  invoiceCount,
  callerName,
  phoneNumber,
  preName,
}: PropsType) => {
  const isRinging = useSelector(
    (state: RootState) => state.callDetail.isRinging
  )
  const dispatch = useDispatch()
  const socket = useContext(SocketContext)
  const phoneCallId = useSelector(
    (state: RootState) => state.callDetail.ringingData.phoneCallId
  )

  useEffect(() => {
    const onHangup = (event: HangupEventType) => {
      console.log('hangup: ', {
        expected: phoneCallId,
        actual: event.phoneCallId,
      })
      if (phoneCallId === event.phoneCallId) {
        dispatch(setIsRinging(false))
        dispatch(resetRingingData())
      }
    }
    socket?.on('hangup', onHangup)
    return () => {
      socket?.off('hangup', onHangup)
    }
  }, [phoneCallId])

  return (
    <Transition
      show={isRinging || false}
      className="fixed left-16 z-[51] bg-white w-[422px] h-[478px] flex flex-col items-center pt-5 rounded-t-lg border-black border-2 bottom-0"
      as="div"
      enter="ease-out duration-300"
      enterFrom="-bottom-full"
      enterTo="-bottom-0"
      leave="ease-in duration-200"
      leaveFrom="bottom-0"
      leaveTo="-bottom-full"
    >
      <span
        className="absolute top-2 right-3 cursor-pointer text-base"
        onClick={() => dispatch(setIsRinging(false))}
      >
        &#10006;
      </span>
      <RingingBlueStar className="absolute right-[60px] top-[126px] w-[25px] h-[25px] opacity-20" />
      <RingingLine className="absolute left-[31px] top-[135px] h-1.5 w-[76px] opacity-20" />
      <RingingYellowStar className="absolute left-[86px] bottom-[27px] h-[35px] w-[35px] opacity-20" />
      <p className="flex w-full justify-center text-[#BCBCBC] font-semibold text-xl mb-8">
        Dialing
      </p>
      <RingingAvatar />
      <PhoneNumberContainer phoneNumber={phoneNumber} />
      <CallerNameContainer
        callerName={`${preName?.label || ''} ${callerName}`}
      />
      <OrderHistory show={invoiceCount !== 0} count={invoiceCount} />
    </Transition>
  )
}

export default Ringing
